import { GetLang, RegisterLang } from '@/api/mu/index.ts'
import { APP_NAME, APP_VERSION } from '@/config/global.ts'
// import { updateI18nData, getI18nData } from '@/indexeddb/i18n.js'
import { useAuthStoreWithOut } from '@/store/modules/auth.ts'
const authStore = useAuthStoreWithOut()

export const GetLocalLang = async (lang) => {
    let orgId = authStore.getOrgInfo.id
    if ((window as any).$wujie) orgId = (window as any).$wujie.props.orgInfo.id
 
    if( window.location.hostname === 'localhost' ) {
        const localLang = await import(`../locales/${lang}.ts`)
        return localLang ? localLang.default : null
    }

    // 从接口读
    let result:any = await GetLangFromBackend(lang)
    // 没读到注册
    if (!result) {
        await RegisterLocalLang()
        // await RegisterLocalLangForMobile()
        result = await GetLangFromBackend(lang)
    }
    
    // 接口没有直接读本地文件
    if (!result) {
        let localLang:any = null
        if (['zh-CN','zh-TW','en'].includes(lang)) {
            localLang = await import(`../locales/${lang}.ts`)
        } else {
            localLang = await import(`../locales/en.ts`)
        }
        result = localLang?localLang.default:null
    }
    console.log('GetLocalLang ',lang,result)
    return result
}

// export const GetLocalLang = async (lang) => {
//     let orgId = authStore.getOrgInfo.id
//     if ((window as any).$wujie) orgId = (window as any).$wujie.props.orgInfo.id
//     // 从缓存读
//     const data:any = await getI18nData(orgId, lang)
//     if (data && data.version === APP_VERSION) return data.data
//     // 从接口读
//     let result:any = await GetLangFromBackend(lang)
//     // 没读到直接注册
//     if (!result) {
//         await RegisterLocalLang()
//         result = await GetLangFromBackend(lang)
//     }
//     // 更新缓存
//     if (result) updateI18nData(orgId, lang, APP_VERSION, result)
//     // 直接读本地文件
//     if (!result) {
//         let localLang:any = null
//         if (['zh-CN','zh-TW','en'].includes(lang)) {
//             localLang = await import(`../locales/${lang}.ts`)
//         } else {
//             localLang = await import(`../locales/en.ts`)
//         }
//         result = localLang?localLang.default:null
//     }
//     console.log('GetLocalLang ',lang,result)
//     return result
// }

export const GetLangFromBackend = async (lang) => {
    let result:any = null
    const param ={
        langCode: lang,
        withI18nData: true,
        app: APP_NAME,
        version: APP_VERSION
    }
    await GetLang(param).then(res => {
        if (res.errorCode !== 0) throw new Error(res.errorMessage)
        if(res && res.data && res.data.i18nData) {
            result = res.data.i18nData
        }
    }).catch(err => {
        console.log(err)
    })
    return result
}

export const RegisterLocalLang = async () => {
    const cnObj = await import(`../locales/zh-CN.ts`)
    const twObj = await import(`../locales/zh-TW.ts`)
    const enObj = await import(`../locales/en.ts`)
    const params = {
        service: APP_NAME,
        version: APP_VERSION,
        builtinI18nData: [
            {
                langCode:'zh-CN',
                i18nData:cnObj.default ?? {}
            },
            {
                langCode:'zh-TW',
                i18nData:twObj.default ?? {}
            },
            {
                langCode:'en',
                i18nData:enObj.default ?? {}
            },
        ] 
    }
    await RegisterLang(params).then(res => {
    }).catch(err => {
        console.log(err)
    })
    return
}

export const RegisterLocalLangForMobile = async () => {
    const cnObj = await import(`../locales/mobile/zh-CN.ts`)
    const twObj = await import(`../locales/mobile/zh-TW.ts`)
    const enObj = await import(`../locales/mobile/en.ts`)
    const params:any = {
        service: APP_NAME,
        version: APP_VERSION,
        i18nDataType: 'MobileApp',
        builtinI18nData: [
            {
                langCode:'zh-CN',
                i18nData:cnObj.default ?? {}
            },
            {
                langCode:'zh-TW',
                i18nData:twObj.default ?? {}
            },
            {
                langCode:'en',
                i18nData:enObj.default ?? {}
            },
        ] 
    }
    await RegisterLang(params).then(res => {
        if (res.errorCode !== 0) throw new Error(res.errorMessage)
    }).catch(err => {
        console.log(err)
    })
    return
}

export const deskLangToLang = (deskLang)=>{
    switch(deskLang){
        case 'zh-cn':
            return 'zh-CN'
        case 'zh-tw':
            return 'zh-TW'
        case 'en':
            return 'en'
        default:
            return deskLang
    }
}
